import Vue from "vue"
import Vuex from "vuex"
import VuexPersistence from "vuex-persist"
import api from "@/services/api"

import basket from "./modules/basket"

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.sessionStorage,
  reducer: state => ({ basket: state.basket })
})

export default new Vuex.Store({
  modules: { basket },
  plugins: [vuexLocal.plugin],
  state: {
    page: {},

    site_id: "lincolnwelding",
    settings: null,
    main_pages: null,
    categories: null,
    brands: null,

    basket_page: null,
    checkout_page: null,

    homeID: "L-rAYnl5g",
    aboutID: "NRRkGzB_m",
    faqsID: "ls4U8RhDd",
    contactID: "RIFFdwEIT",
    privacyID: "KbJj8Ynbk",
    termsID: "sygr6Ef7Z",
    checkoutID: "dhdobcAFk",
    cartID: "iq_bHW-Lz",
    successID: "_mZXMvqyM",
    failureID: "AK6idVVp6"
  },
  getters: {
    isHomePage(state) {
      return state.page.ItemID && state.page.ItemID == state.homeID
    },
    isFaqsPage(state) {
      return state.page.ItemID && state.page.ItemID == state.faqsID
    },
    isCartPage(state) {
      return state.page.ItemID && state.page.ItemID == state.cartID
    },
    isProduct(state) {
      return state.page.ItemType && state.page.ItemType == "page.products"
    },
    isCategory(state) {
      return state.page.ItemType && state.page.ItemType == "page.categories"
    },
    isSub(state) {
      return state.page.ItemType && state.page.ItemType == "page.sub"
    },
    isMainPage(state) {
      return state.page.ItemType && state.page.ItemType == "page.main"
    },
    isBrand(state) {
      return state.page.ItemType && state.page.ItemType == "page.brands"
    },
    isContactPage(state) {
      return state.page.ItemID && state.page.ItemID == state.contactID
    },
    isCheckoutPage(state) {
      return state.page.ItemID && state.page.ItemID == state.checkoutID
    },
    topLinks(state) {
      if (!state.main_pages) return []
      return state.main_pages.slice(0, 4)
    },
    infoMenu(state) {
      if (!state.main_pages) return []
      return state.main_pages.filter(p => [state.aboutID, state.faqsID, state.contactID].includes(p.ItemID))
    },
    legalMenu(state) {
      if (!state.main_pages) return []
      return state.main_pages.filter(p => [state.privacyID, state.termsID].includes(p.ItemID))
    },
    isSuccess(state) {
      return state.page.ItemID && state.page.ItemID == state.successID
    },
    isFailure(state) {
      return state.page.ItemID && state.page.ItemID == state.failureID
    }
  },
  mutations: {
    setPage(state, page) {
      state.page = page
    },
    setSettings(state, settings) {
      state.settings = settings
    },
    setMainPages(state, main_pages) {
      state.main_pages = main_pages

      main_pages.forEach(page => {
        // if (page.ItemID == state.IDs.contactID) state.contact_page = page
        // if (page.ItemID == state.IDs.helpID) state.help_page = page
        // if (page.ItemID == state.IDs.faqsID) state.faqs_page = page

        if (page.ItemID == state.cartID) state.basket_page = page
        if (page.ItemID == state.checkoutID) state.checkout_page = page
      })
    },
    setBrands(state, brands) {
      state.brands = brands
    },
    setCategories(state, categories) {
      state.categories = categories
    }
  },
  actions: {
    getSettings({ commit, state }) {
      return new Promise(resolve => {
        if (!state.settings)
          api.getPageByItemID("SETTINGS").then(settings => {
            commit("setSettings", settings)
            resolve()
          })
        else resolve()
      })
    },
    getMainPages({ commit, state }) {
      return new Promise(resolve => {
        if (!state.main_pages)
          api.getPages("", "page.main").then(main_pages => {
            commit("setMainPages", main_pages)
            resolve()
          })
        else resolve()
      })
    },
    getBrands({ commit, state }) {
      return new Promise(resolve => {
        if (!state.brands)
          api.getPages("logo", "page.brands").then(brands => {
            commit("setBrands", brands)
            resolve()
          })
        else resolve()
      })
    },
    getCategories({ commit, state }) {
      return new Promise(resolve => {
        if (!state.categories)
          api.getPages("", "page.categories").then(categories => {
            commit("setCategories", categories)

            var promises = []

            categories.forEach(page => {
              promises.push(api.getPages("", "page.sub=@" + page.ItemID).then(subs => Vue.set(page, "subs", subs)))
            })

            Promise.all(promises).then(() => {
              commit("setCategories", categories)
              resolve(categories)
            })
          })
        else resolve(state.categories)
      })
    }
  }
})
